var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDocument(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13.75,
    height: 19.25,
    viewBox: "0 0 13.75 19.25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-6.75 -2.251)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.293,7.269,15.481,2.457A.624.624,0,0,0,15,2.251H8.125A1.379,1.379,0,0,0,6.75,3.626v16.5A1.379,1.379,0,0,0,8.125,21.5h11A1.379,1.379,0,0,0,20.5,20.126V7.75a.625.625,0,0,0-.206-.481ZM15,3.9l3.85,3.85H15Zm4.125,16.225h-11V3.625h5.5V7.75A1.379,1.379,0,0,0,15,9.125h4.125Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.25,24.75H19.5v1.375H11.25Z",
    transform: "translate(-1.75 -8.75)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.25,18H19.5v1.375H11.25Z",
    transform: "translate(-1.75 -6.125)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocument);
export default __webpack_public_path__ + "static/media/document.975593d2b71db010159477e7a44342f1.svg";
export { ForwardRef as ReactComponent };